
export const constants = {
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    ESC: 27,
    SPACE: 32,
    ENTER: 13,
    TAB: 9
}

export function capitalize (s = '') {
    return s[0].toUpperCase() + s.slice(1)
}

export function pxToEm (target, stripedInnerFontSize = 1) {
    return ((target / 14) / stripedInnerFontSize * 1) + 'em'
}

export function percent (target) {
    return target + '%'
}